webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(33);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(51);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(50);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _login = __webpack_require__(36);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(39);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _profile = __webpack_require__(38);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	var _todolist = __webpack_require__(40);
	
	var _todolist2 = _interopRequireDefault(_todolist);
	
	var _manage = __webpack_require__(37);
	
	var _manage2 = _interopRequireDefault(_manage);
	
	var _welcome = __webpack_require__(8);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	var router = new _vueRouter2.default({
		mode: 'history',
		base: __dirname,
		routes: [{
			path: '/',
			component: _todolist2.default
		}, {
			path: '/login',
			component: _login2.default
		}, {
			path: '/register',
			component: _register2.default
		}, {
			path: '/profile',
			component: _profile2.default
		}, {
			path: '/todolist',
			component: _todolist2.default
		}, {
			path: '/manage',
			component: _manage2.default
		}]
	});
	var app = new _vue2.default({
		router: router,
		render: function render(h) {
			return h(_App2.default);
		}
	}).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STORAGE_KEY = "user-vuejs";
	exports.default = {
		fetch: function fetch() {
			return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
		},
		save: function save(items) {
			window.localStorage.setItem(STORAGE_KEY, (0, _stringify2.default)(items));
		}
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		findElem: function findElem(arrayToSearch, attr, val) {
			for (var i = 0; i < arrayToSearch.length; i++) {
				if (arrayToSearch[i][attr] == val) {
					return i;
				}
			}
			return -1;
		}
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(52);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _storeusercurr = __webpack_require__(4);
	
	var _storeusercurr2 = _interopRequireDefault(_storeusercurr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
		state: {
			cid: _storeusercurr2.default.fetch() == "" ? "" : _storeusercurr2.default.fetch()[0].cid,
			cname: _storeusercurr2.default.fetch() == "" ? "" : _storeusercurr2.default.fetch()[0].cname,
			isLogin: _storeusercurr2.default.fetch() == "" ? "" : _storeusercurr2.default.fetch()[0].islogin
		},
		strict: true,
		mutations: {
			login: function login(state) {
				state.cid = _storeusercurr2.default.fetch()[0].cid, state.cname = _storeusercurr2.default.fetch()[0].cname, state.isLogin = _storeusercurr2.default.fetch()[0].islogin;
			},
			singout: function singout(state) {
				state.cid = "", state.cname = "", state.isLogin = false;
			}
		}
	});
	
	module.exports = store;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STORAGE_KEY = "usercurr";
	exports.default = {
		fetch: function fetch() {
			return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '[]');
		},
		save: function save(items) {
			window.sessionStorage.setItem(STORAGE_KEY, (0, _stringify2.default)(items));
		}
	};

/***/ },
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(30)
	
	/* script */
	__vue_exports__ = __webpack_require__(18)
	
	/* template */
	var __vue_template__ = __webpack_require__(48)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-ccc6eaa4"
	
	module.exports = __vue_exports__


/***/ },
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _header = __webpack_require__(35);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(34);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _welcome = __webpack_require__(8);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _storeGlobal = __webpack_require__(3);
	
	var _storeGlobal2 = _interopRequireDefault(_storeGlobal);
	
	var _storeusercurr = __webpack_require__(4);
	
	var _storeusercurr2 = _interopRequireDefault(_storeusercurr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		components: {
			vheader: _header2.default, vfooter: _footer2.default, welcome: _welcome2.default
		},
		data: function data() {
			return {
				user: _storeusercurr2.default.fetch()
			};
		},
	
		mounted: function mounted() {
			console.log("当前是否已登录:" + (_storeGlobal2.default.state.isLogin ? " 是 " : " 否 ") + " ,当前id为 " + _storeGlobal2.default.state.cid);
		}
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'footer'
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _storeGlobal = __webpack_require__(3);
	
	var _storeGlobal2 = _interopRequireDefault(_storeGlobal);
	
	var _storeuser = __webpack_require__(1);
	
	var _storeuser2 = _interopRequireDefault(_storeuser);
	
	var _storeusercurr = __webpack_require__(4);
	
	var _storeusercurr2 = _interopRequireDefault(_storeusercurr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'header',
		data: function data() {
			return {
				isLogin: _storeGlobal2.default.state.isLogin,
				cname: "",
				users: _storeuser2.default.fetch(),
				user: _storeusercurr2.default.fetch()
			};
		},
	
		components: {},
		mounted: function mounted() {
			if (_storeGlobal2.default.state.isLogin) {
				this.cname = _storeusercurr2.default.fetch()[0]["cname"], this.isLogin = true;
			}
		},
		methods: {
			signout: function signout() {
				if (!confirm("确定退出吗")) {
					return;
				}
	
				window.location.href = "./";
				_storeGlobal2.default.commit('singout');
				this.user = [];
				this.user.push({
					cid: "",
					islogin: false
				});
				_storeusercurr2.default.save(this.user);
			}
		}
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _storeuser = __webpack_require__(1);
	
	var _storeuser2 = _interopRequireDefault(_storeuser);
	
	var _md = __webpack_require__(6);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _findElem = __webpack_require__(2);
	
	var _findElem2 = _interopRequireDefault(_findElem);
	
	var _storeGlobal = __webpack_require__(3);
	
	var _storeGlobal2 = _interopRequireDefault(_storeGlobal);
	
	var _storeusercurr = __webpack_require__(4);
	
	var _storeusercurr2 = _interopRequireDefault(_storeusercurr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'todolist',
		data: function data() {
			return {
				name: "",
				pwd: "",
				msg: "",
				cid: "",
				users: _storeuser2.default.fetch(),
				user: _storeusercurr2.default.fetch(),
				hasLogin: false
			};
		},
	
		watch: {},
		methods: {
			login: function login() {
				if (this.name.trim() == "") {
					this.msg = "请输入用户名";
					return;
				}
				if (this.pwd.trim() == "") {
					this.msg = "请输入密码";
					return;
				}
				var exist = _findElem2.default.findElem(this.users, "name", this.name);
				var existpwd = _findElem2.default.findElem(this.users, "pwd", (0, _md2.default)(this.pwd));
				if (exist == -1) {
					this.msg = "该用户名未注册";
					return;
				}
				if (exist != -1 && this.users[exist]["pwd"] != (0, _md2.default)(this.pwd)) {
					this.msg = "密码错误";
					return;
				}
				if (exist != -1 && this.users[exist]["pwd"] == (0, _md2.default)(this.pwd)) {
					this.user = [];
					this.user.push({
						cid: this.users[exist]["id"],
						cname: this.users[exist]["name"],
						islogin: true
					});
					_storeusercurr2.default.save(this.user);
					_storeGlobal2.default.commit('login');
					this.hasLogin = true;
					alert("登录成功");
					window.location.href = "./";
				}
			},
			clearMsg: function clearMsg() {
				this.msg = "";
			}
		}
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _storeuser = __webpack_require__(1);
	
	var _storeuser2 = _interopRequireDefault(_storeuser);
	
	var _findElem = __webpack_require__(2);
	
	var _findElem2 = _interopRequireDefault(_findElem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'management',
		data: function data() {
			return {
				items: []
			};
		},
	
		watch: {},
		methods: {}
	
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _storeGlobal = __webpack_require__(3);
	
	var _storeGlobal2 = _interopRequireDefault(_storeGlobal);
	
	var _storeuser = __webpack_require__(1);
	
	var _storeuser2 = _interopRequireDefault(_storeuser);
	
	var _md = __webpack_require__(6);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _findElem = __webpack_require__(2);
	
	var _findElem2 = _interopRequireDefault(_findElem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'profile',
		data: function data() {
			return {
				users: _storeuser2.default.fetch(),
				id: _storeGlobal2.default.state.cid,
				name: _storeGlobal2.default.state.cname,
				tel: "",
				email: "",
				pwd: "",
				msg: ""
			};
		},
	
		watch: {
			users: {
				handler: function handler(users) {
					_storeuser2.default.save(users);
				},
				deep: true
			}
		},
		mounted: function mounted() {
			var exist = _findElem2.default.findElem(this.users, "name", this.name);
			this.tel = this.users[exist].tel || "";
			this.email = this.users[exist].email || "";
		},
		methods: {
			resetprofile: function resetprofile() {
				var exist = _findElem2.default.findElem(this.users, "name", this.name);
				var existpwd = _findElem2.default.findElem(this.users, "pwd", (0, _md2.default)(this.pwd));
	
				this.users[exist].tel = this.users[exist].tel || "";
				this.users[exist].email = this.users[exist].email || "";
	
				if (this.tel.trim() == this.users[exist].tel && this.email.trim() == this.users[exist].email) {
					this.msg = "您没有修改";
					return;
				}
				if (this.tel.trim() != this.users[exist].tel || this.email.trim() != this.users[exist].email) {
					if (this.pwd.trim() == "") {
						this.msg = "请确认密码";
						return;
					}
					if (this.users[exist]["pwd"] != (0, _md2.default)(this.pwd)) {
						this.msg = "密码错误";
						return;
					}
					if (this.users[exist]["pwd"] == (0, _md2.default)(this.pwd)) {
						this.users[exist].tel = this.tel, this.users[exist].email = this.email;
						_storeuser2.default.save(this.users);
						alert("修改成功");
						window.location.href = "./";
					}
				}
			},
			clearMsg: function clearMsg() {
				this.msg = "";
			}
		}
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _storeuser = __webpack_require__(1);
	
	var _storeuser2 = _interopRequireDefault(_storeuser);
	
	var _md = __webpack_require__(6);
	
	var _md2 = _interopRequireDefault(_md);
	
	var _findElem = __webpack_require__(2);
	
	var _findElem2 = _interopRequireDefault(_findElem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'register',
		data: function data() {
			return {
				newName: "",
				newPwd: "",
				msg: "",
				id: "",
				users: _storeuser2.default.fetch(),
				isRegister: false
			};
		},
	
		watch: {
			users: {
				handler: function handler(users) {
					_storeuser2.default.save(users);
				},
				deep: true
			},
			isRegister: {
				handler: function handler(isRegister) {
					if (isRegister) {
						this.$router.push({
							path: '/login',
							redirect: function redirect(to) {
								login;
							}
						});
					}
				},
				deep: true
			}
		},
		methods: {
			addUser: function addUser() {
				if (this.newName.trim() == "") {
					this.msg = "请输入用户名";
					return;
				}
				var exist = _findElem2.default.findElem(this.users, "name", this.newName);
				if (exist != -1) {
					this.msg = "该用户名已被注册";
					return;
				}
				if (this.newPwd.trim() == "") {
					this.msg = "请输入密码";
					return;
				}
				if (this.$refs.checkPwd.value.trim() == "") {
					this.msg = "请确认密码";
					return;
				}
				if (this.newPwd != this.$refs.checkPwd.value) {
					this.msg = "两次密码不一致";
					return;
				}
				this.id = "vl_" + new Date().getTime() + Math.floor(Math.random() * 100);
				this.users.push({
					id: this.id,
					name: this.newName,
					pwd: (0, _md2.default)(this.newPwd)
				});
				this.isRegister = true;
				alert("注册成功");
			},
			clearMsg: function clearMsg() {
				this.msg = "";
			}
		}
	
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _storelist = __webpack_require__(19);
	
	var _storelist2 = _interopRequireDefault(_storelist);
	
	var _findElem = __webpack_require__(2);
	
	var _findElem2 = _interopRequireDefault(_findElem);
	
	var _storeGlobal = __webpack_require__(3);
	
	var _storeGlobal2 = _interopRequireDefault(_storeGlobal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'todolist',
		data: function data() {
			return {
				allitems: _storelist2.default.fetch(),
				newItem: "",
				name: "",
				id: "",
				msg: "",
				isActive: true,
				showFinishedList: false,
				items: [],
				typeLists: [],
				currIndex: "",
				isIndex: -1,
				showInListType: false,
				isShowEdit: false,
				newType: "",
				mainItems: [],
				selectedIndex: -1,
				showDeleteConfirm: false,
				isShowEditType: false,
				showEditTypeConfirm: false
			};
		},
	
		watch: {
			allitems: {
				handler: function handler(allitems) {
					_storelist2.default.save(allitems);
				},
				deep: true
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			this.allitems.forEach(function (item) {
				if (item.id == _storeGlobal2.default.state.cid) {
					if (item.plan.trim() != "") {
						_this.items.push(item);
					}
	
					_this.mainItems.push(item);
				}
			});
	
			this.mainItems.forEach(function (item) {
				if (_this.typeLists.indexOf(item.subtype) < 0) {
					_this.typeLists.push(item.subtype);
				}
			});
		},
		methods: {
			showAddTypeModal: function showAddTypeModal() {
				if (!_storeGlobal2.default.state.cid) {
					this.msg = "请先登录";
					return;
				}
				this.showInListType = true;
			},
			manageList: function manageList() {
				if (!_storeGlobal2.default.state.cid) {
					this.msg = "请先登录";
					return;
				}
				console.log(this.typeLists.length);
				if (this.typeLists.length < 1) {
					alert("暂无分类可以管理，请先新建分类");
					return;
				}
				this.isShowEditType = true;
			},
	
			getCurrItems: function getCurrItems() {
				var _this2 = this;
	
				this.items = [];
				this.mainItems = [];
				this.allitems.forEach(function (item) {
					if (item.id == _storeGlobal2.default.state.cid) {
						if (item.plan.trim() != "") {
							_this2.items.push(item);
						}
	
						_this2.mainItems.push(item);
					}
				});
			},
	
			getTypeLists: function getTypeLists() {
				var _this3 = this;
	
				this.typeLists = [];
				this.mainItems.forEach(function (item) {
					if (_this3.typeLists.indexOf(item.subtype) < 0) {
						_this3.typeLists.push(item.subtype);
					}
				});
			},
	
			getOtherLists: function getOtherLists() {
				var _this4 = this;
	
				this.getCurrItems();
				this.items = [];
				this.mainItems.forEach(function (item) {
					if (item.subtype == _this4.currIndex && item.plan.trim() != "") {
						_this4.items.push(item);
					}
				});
			},
	
			showAllLists: function showAllLists() {
				if (!_storeGlobal2.default.state.cid) {
					this.msg = "请先登录";
					return;
				}
				this.isActive = true;
				this.isIndex = -1;
				this.getCurrItems();
				this.getTypeLists();
			},
	
			showCurrList: function showCurrList(index) {
				this.currIndex = this.typeLists[index];
				this.isActive = false;
				this.isIndex = index;
				this.getCurrItems();
				this.getOtherLists();
			},
	
			addActive: function addActive(index) {
				this.selectedIndex = index;
			},
	
			showEdit: function showEdit(item) {
				this.isShowEdit = false;
				this.item = item;
				this.editItem = this.item;
				this.isShowEdit = true;
			},
			hideEdit: function hideEdit(item) {
				if (this.item.plan.trim() == "") {
					this.showDeleteConfirm = true;
				} else {
					this.isShowEdit = false;
				}
			},
			hideEditType: function hideEditType() {
				this.isShowEditType = false;
			},
			checkEmpty: function checkEmpty(editItem) {
				if (this.item.plan.trim() == "") {
					this.showDeleteConfirm = true;
				}
			},
			checkEmptyType: function checkEmptyType(index) {
				this.editTypeIndex = index;
				if (this.typeLists[index].trim() == "") {
					this.showEditTypeConfirm = true;
				}
			},
			deleteList: function deleteList() {
				this.showDeleteConfirm = false;
				this.isShowEdit = false;
				this.item.type = "";
				this.item.plan = "";
				this.getCurrItems();
				this.isActive ? this.getTypeLists() : this.getOtherLists();
			},
			deleteType: function deleteType() {
				this.showEditTypeConfirm = false;
				this.isShowEditType = false;
			},
			deleteTypePlan: function deleteTypePlan() {
				this.showEditTypeConfirm = false;
				this.isShowEditType = false;
			},
	
			toggleFinished: function toggleFinished(item) {
				item.isfinished = !item.isfinished;
			},
	
			toggleFinishedList: function toggleFinishedList() {
				this.showFinishedList = !this.showFinishedList;
			},
			showDefault: function showDefault() {
				var len = _findElem2.default.findElem(this.items, "isfinished", true);
				if (len < 0) {
					return true;
				} else {
					return false;
				}
			},
			checkLogin: function checkLogin() {
				if (!_storeGlobal2.default.state.cid) {
					this.msg = "请先登录";
				}
			},
			clearMsg: function clearMsg() {
				this.msg = "";
			},
			addItem: function addItem() {
				if (this.newItem.trim() == "") {
					return;
				}
				if (!_storeGlobal2.default.state.cid) {
					this.msg = "请先登录";
					return;
				}
				this.allitems.push({
					id: _storeGlobal2.default.state.cid,
					plan: this.newItem,
					subtype: this.isActive ? "未分类" : this.currIndex,
					isfinished: false
				});
				this.getCurrItems();
				this.getTypeLists();
				this.isActive ? this.getTypeLists() : this.getOtherLists();
				this.newItem = "";
			},
			addNewType: function addNewType() {
				if (!_storeGlobal2.default.state.cid) {
					this.msg = "请先登录";
					return;
				}
				if (this.newType.trim() == "") {
					return;
				}
				this.allitems.push({
					id: _storeGlobal2.default.state.cid,
					plan: "",
					subtype: this.newType,
					isfinished: false
				});
				this.getCurrItems();
				this.getTypeLists();
				this.isActive ? this.getTypeLists() : this.getOtherLists();
				this.newType = "";
				this.showInListType = false;
			}
		}
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'welcome'
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STORAGE_KEY = "todolist-vuejs";
	exports.default = {
		fetch: function fetch() {
			return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
		},
		save: function save(items) {
			window.localStorage.setItem(STORAGE_KEY, (0, _stringify2.default)(items));
		},
		delete: function _delete(id) {
			window.localStorage.removeItem(id);
		}
	};

/***/ },
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 24 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 25 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 26 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 27 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 28 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 29 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 30 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 31 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 32 */,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(28)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(46)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(24)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(42)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-40cbde7f"
	
	module.exports = __vue_exports__


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(25)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(43)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-61fe4271"
	
	module.exports = __vue_exports__


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(27)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(45)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9cd13f96"
	
	module.exports = __vue_exports__


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(31)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(49)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-fe6a5d6e"
	
	module.exports = __vue_exports__


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(29)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(47)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b7260516"
	
	module.exports = __vue_exports__


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(23)
	
	/* script */
	__vue_exports__ = __webpack_require__(16)
	
	/* template */
	var __vue_template__ = __webpack_require__(41)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3d15d087"
	
	module.exports = __vue_exports__


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(26)
	
	/* script */
	__vue_exports__ = __webpack_require__(17)
	
	/* template */
	var __vue_template__ = __webpack_require__(44)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-95ccc170"
	
	module.exports = __vue_exports__


/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "register"
	    }
	  }, [_h('div', {
	    staticClass: "form_main"
	  }, [_h('div', {
	    staticClass: "form"
	  }, [_h('p', {
	    staticClass: "tit_form"
	  }, ["注　册"]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', ["昵　　称:"]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newName),
	      expression: "newName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入您的用户名"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newName)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.addUser($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newName = $event.target.value
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', ["密　　码:"]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPwd),
	      expression: "newPwd"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "请输入您的密码"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newPwd)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.addUser($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPwd = $event.target.value
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', ["确认密码"]), " ", _h('input', {
	    ref: "checkPwd",
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "请确认您的密码"
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.addUser($event)
	      }
	    }
	  })]), " ", _h('p', {
	    ref: "msg",
	    staticClass: "message"
	  }, [_vm._s(_vm.msg)]), " ", _h('p', {
	    staticClass: "tit_form"
	  }), " ", _h('div', {
	    staticClass: "text-center"
	  }, [_h('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.addUser
	    }
	  }, ["注册"])])])])])
	},staticRenderFns: []}

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "footer"
	  }, [_h('p', ["Copyright © 2017 HannaLiu."])])
	}]}

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('header', [_h('nav', {
	    staticClass: "container header"
	  }, [_vm._m(0), " ", _h('div', {
	    staticClass: "nav-person"
	  }, [(!_vm.isLogin) ? _h('div', {
	    staticClass: "nav-login"
	  }, [_h('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "href": "#",
	      "role": "button"
	    }
	  }, [_h('router-link', {
	    attrs: {
	      "to": "/register"
	    }
	  }, ["注册"])]), " ", _h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "href": "#",
	      "role": "button"
	    }
	  }, [_h('router-link', {
	    attrs: {
	      "to": "/login"
	    }
	  }, ["登录"])])]) : _h('div', {
	    staticClass: "nav-login"
	  }, [_h('div', {
	    staticClass: "user-name"
	  }, [_h('router-link', {
	    attrs: {
	      "to": "/profile"
	    }
	  }, [_vm._s(_vm.cname)])]), " ", _h('button', {
	    staticClass: "btn btn-warning",
	    attrs: {
	      "href": "#",
	      "role": "button"
	    },
	    on: {
	      "click": _vm.signout
	    }
	  }, ["退出"])]), " "]), " ", _h('ul', {
	    staticClass: "nav-menu"
	  }, [_h('li', [_h('router-link', {
	    attrs: {
	      "to": "/todolist"
	    }
	  }, ["TODO"])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('h1', {
	    staticClass: "logo"
	  }, [_h('p', {
	    staticClass: "logo_txt"
	  }, ["TODOList"])])
	}]}

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "todolist"
	    }
	  }, [_h('div', {
	    staticClass: "form_main"
	  }, [_h('div', [_h('div', {
	    staticClass: "btn-group m_t_m typeBtn",
	    attrs: {
	      "role": "group"
	    }
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    class: {
	      'btn-success': _vm.isActive
	    },
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showAllLists
	    }
	  }, ["全部"]), " ", _vm._l((_vm.typeLists), function(typeList, index) {
	    return _h('button', {
	      staticClass: "btn btn-default",
	      class: {
	        'btn-success': _vm.isIndex == index ? true : false
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          _vm.showCurrList(index)
	        }
	      }
	    }, [_vm._s(typeList)])
	  }), " ", _h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.showAddTypeModal
	    }
	  }, [_h('i', {
	    staticClass: "fa fa-plus"
	  })]), " "]), " ", _h('span', {
	    staticClass: "message"
	  }, [_vm._s(_vm.msg)])]), " ", (_vm.showInListType) ? _h('div', [_h('div', {
	    staticClass: "model"
	  }, [_h('div', {
	    staticClass: "modal-dialog"
	  }, [_h('div', {
	    staticClass: "modal-content"
	  }, [_h('div', {
	    staticClass: "modal-header"
	  }, [_h('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_h('span', {
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showInListType = false
	      }
	    }
	  }, ["×"])]), " ", _h('h4', {
	    staticClass: "modal-title"
	  }, ["为新增的分类取个名字"])]), " ", _h('div', {
	    staticClass: "modal-body"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newType),
	      expression: "newType"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入分类的名称"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newType)
	    },
	    on: {
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.addNewType($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newType = $event.target.value
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "modal-footer"
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showInListType = false
	      }
	    }
	  }, ["取消"]), " ", _h('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addNewType
	    }
	  }, ["确定"])])])])])]) : _vm._e(), " ", _h('div', [_h('div', [_h('div', {
	    staticClass: "input-group m_t_s m_b_s"
	  }, [_h('span', {
	    staticClass: "input-group-btn"
	  }, [_h('button', {
	    staticClass: "btn btn-default btn-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.addItem
	    }
	  }, ["+"])]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newItem),
	      expression: "newItem"
	    }],
	    staticClass: "form-control input-lg",
	    attrs: {
	      "type": "text",
	      "placeholder": "添加计划..."
	    },
	    domProps: {
	      "value": _vm._s(_vm.newItem)
	    },
	    on: {
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.addItem($event)
	      },
	      "focus": _vm.checkLogin,
	      "blur": _vm.clearMsg,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newItem = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "task-list"
	  }, [_h('ul', [_vm._l((_vm.items), function(item, index) {
	    return (!item.isfinished) ? _h('li', {
	      staticClass: "plan_list",
	      class: [{
	        finished: item.isfinished
	      }, {
	        'active': _vm.selectedIndex == index ? true : false
	      }],
	      on: {
	        "dblclick": function($event) {
	          _vm.showEdit(item)
	        }
	      }
	    }, [_h('div', {
	      staticClass: "labelforlist"
	    }, [_h('label', {
	      staticClass: "checkboxInput"
	    }, [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.isfinished),
	        expression: "item.isfinished"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(item.isfinished) ? _vm._i(item.isfinished, null) > -1 : _vm._q(item.isfinished, true)
	      },
	      on: {
	        "click": _vm.toggleFinished,
	        "change": function($event) {
	          var $$a = item.isfinished,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (item.isfinished = $$a.concat($$v))
	            } else {
	              $$i > -1 && (item.isfinished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            item.isfinished = $$c
	          }
	        }
	      }
	    })]), " ", _h('span', {
	      staticClass: "item_plan",
	      on: {
	        "click": function($event) {
	          _vm.addActive(index)
	        }
	      }
	    }, [_vm._s(item.plan)])])]) : _vm._e()
	  })])]), " ", _h('div', {
	    staticClass: "task-list"
	  }, [(!_vm.showFinishedList) ? _h('button', {
	    staticClass: "btn btn-success m_t_s",
	    on: {
	      "click": _vm.toggleFinishedList
	    }
	  }, ["收起已完成任务"]) : _h('button', {
	    staticClass: "btn btn-success m_t_s",
	    on: {
	      "click": _vm.toggleFinishedList
	    }
	  }, ["显示已完成任务"]), " ", " ", (!_vm.showFinishedList) ? _h('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_h('ul', [_h('li', [(_vm.showDefault()) ? _h('h5', ["暂无完成任务"]) : _h('h5', ["以下为完成任务"]), " "]), " ", _vm._l((_vm.items), function(item, index) {
	    return (item.isfinished) ? _h('li', {
	      staticClass: "plan_list plan_list_done",
	      class: [{
	        finished: item.isfinished
	      }, {
	        'active': _vm.selectedIndex == index ? true : false
	      }],
	      on: {
	        "dblclick": function($event) {
	          _vm.showEdit(item)
	        }
	      }
	    }, [_h('div', {
	      staticClass: "labelforlist"
	    }, [_h('label', {
	      staticClass: "checkboxInput"
	    }, [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (item.isfinished),
	        expression: "item.isfinished"
	      }],
	      staticClass: "nochecked",
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(item.isfinished) ? _vm._i(item.isfinished, null) > -1 : _vm._q(item.isfinished, true)
	      },
	      on: {
	        "click": _vm.toggleFinished,
	        "change": function($event) {
	          var $$a = item.isfinished,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (item.isfinished = $$a.concat($$v))
	            } else {
	              $$i > -1 && (item.isfinished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            item.isfinished = $$c
	          }
	        }
	      }
	    })]), " ", _h('span', {
	      staticClass: "item_plan line-through",
	      on: {
	        "click": function($event) {
	          _vm.addActive(index)
	        }
	      }
	    }, [_vm._s(item.plan)])])]) : _vm._e()
	  })])]) : _vm._e()])]), " ", _h('transition', {
	    attrs: {
	      "name": "slide-fade"
	    }
	  }, [(_vm.isShowEdit) ? _h('div', {
	    staticClass: "fixedEdit"
	  }, [_h('i', {
	    staticClass: "fa fa-angle-double-right arrow",
	    on: {
	      "click": _vm.hideEdit
	    }
	  }), " ", _h('i', {
	    staticClass: "fa fa-trash delete",
	    on: {
	      "click": function($event) {
	        _vm.showDeleteConfirm = true
	      }
	    }
	  }), " ", _h('div', {
	    staticClass: "labelforlist m_t_m editMain clearfix"
	  }, [_h('label', {
	    staticClass: "checkboxInput float_l"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.isfinished),
	      expression: "item.isfinished"
	    }],
	    class: {
	      'nochecked': _vm.item.isfinished
	    },
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.item.isfinished) ? _vm._i(_vm.item.isfinished, null) > -1 : _vm._q(_vm.item.isfinished, true)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.item.isfinished,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.item.isfinished = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.item.isfinished = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.item.isfinished = $$c
	        }
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "col-xs-11"
	  }, [_h('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.item.plan),
	      expression: "item.plan"
	    }],
	    staticClass: "form-control editText",
	    attrs: {
	      "tabindex": "0"
	    },
	    domProps: {
	      "value": _vm._s(_vm.item.plan)
	    },
	    on: {
	      "blur": function($event) {
	        _vm.checkEmpty()
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.item.plan = $event.target.value
	      }
	    }
	  })]), " ", " "])]) : _vm._e()]), " ", _h('transition', {
	    attrs: {
	      "name": "slide-fade"
	    }
	  }, [(_vm.isShowEditType) ? _h('div', {
	    staticClass: "fixedEdit"
	  }, [_h('i', {
	    staticClass: "fa fa-angle-double-right arrow",
	    on: {
	      "click": _vm.hideEditType
	    }
	  }), " ", _vm._l((_vm.typeLists), function(type, index) {
	    return _h('div', {
	      staticClass: "m_t_s"
	    }, [_h('div', {
	      staticClass: "col-xs-11"
	    }, [_h('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.typeLists[index]),
	        expression: "typeLists[index]"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text"
	      },
	      domProps: {
	        "value": _vm._s(_vm.typeLists[index])
	      },
	      on: {
	        "blur": function($event) {
	          _vm.checkEmptyType(index)
	        },
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          var $$exp = _vm.typeLists,
	            $$idx = index;
	          if (!Array.isArray($$exp)) {
	            _vm.typeLists[index] = $event.target.value
	          } else {
	            $$exp.splice($$idx, 1, $event.target.value)
	          }
	        }
	      }
	    })]), " ", _h('i', {
	      staticClass: "fa fa-trash",
	      on: {
	        "click": function($event) {
	          _vm.showEditTypeConfirm = true
	        }
	      }
	    })])
	  })]) : _vm._e()]), " ", (_vm.showDeleteConfirm) ? _h('div', [_h('div', {
	    staticClass: "model text-center"
	  }, [_h('div', {
	    staticClass: "modal-dialog modal-sm"
	  }, [_h('div', {
	    staticClass: "modal-content"
	  }, [_h('div', {
	    staticClass: "modal-header"
	  }, [_h('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_h('span', {
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showInListType = false
	      }
	    }
	  }, ["×"])]), " ", _h('h4', {
	    staticClass: "modal-title"
	  }, ["确定删除吗"])]), " ", _h('div', {
	    staticClass: "modal-body"
	  }, [_h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showDeleteConfirm = false
	      }
	    }
	  }, ["取消"]), " ", _h('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteList
	    }
	  }, ["确定"])])])])])]) : _vm._e(), " ", (_vm.showEditTypeConfirm) ? _h('div', [_h('div', {
	    staticClass: "model text-center"
	  }, [_h('div', {
	    staticClass: "modal-dialog"
	  }, [_h('div', {
	    staticClass: "modal-content"
	  }, [_h('div', {
	    staticClass: "modal-header"
	  }, [_h('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_h('span', {
	    attrs: {
	      "aria-hidden": "true"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showInListType = false
	      }
	    }
	  }, ["×"])]), " ", _h('h4', {
	    staticClass: "modal-title"
	  }, ["确定删除该分类吗"])]), " ", _h('div', {
	    staticClass: "modal-body"
	  }, [_h('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteTypePlan
	    }
	  }, ["删除该类及该类下的计划"]), " ", _h('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteType
	    }
	  }, ["只删除该类，不删除该类下的计划"]), " ", _h('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showEditTypeConfirm = false
	      }
	    }
	  }, ["取消删除"])])])])])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "login"
	    }
	  }, [_h('div', {
	    staticClass: "form_main"
	  }, [_h('div', {
	    staticClass: "form"
	  }, [_h('p', {
	    staticClass: "tit_form"
	  }, ["登　录"]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', ["昵　　称:"]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入您的用户名"
	    },
	    domProps: {
	      "value": _vm._s(_vm.name)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.login($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', ["密　　码:"]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pwd),
	      expression: "pwd"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "请输入您的密码"
	    },
	    domProps: {
	      "value": _vm._s(_vm.pwd)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "keyup": function($event) {
	        if ($event.keyCode !== 13) { return; }
	        _vm.login($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pwd = $event.target.value
	      }
	    }
	  })]), " ", _h('p', {
	    staticClass: "message"
	  }, [_vm._s(_vm.msg)]), " ", _h('p', {
	    staticClass: "tit_form"
	  }), " ", _h('div', {
	    staticClass: "text-center"
	  }, [_h('button', {
	    staticClass: "btn btn-success",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.login
	    }
	  }, ["登录"])])])])])
	},staticRenderFns: []}

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('vheader'), " ", _h('welcome'), " ", _h('router-view'), " ", _h('vfooter')])
	},staticRenderFns: []}

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "profile"
	    }
	  }, [_h('div', {
	    staticClass: "form_main"
	  }, [_h('div', {
	    staticClass: "m_t_m col-sm-8 col-sm-push-2 grout_list"
	  }, [_h('div', {}, [_h('p', {
	    staticClass: "tit_form"
	  }, ["个人信息"]), " ", " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', {
	    staticClass: "control-label"
	  }, ["用户名："]), " ", _h('div', {
	    staticClass: "info_detail"
	  }, [_h('p', {
	    staticClass: "form-control-static"
	  }, [_vm._s(_vm.name)]), " "])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', {
	    staticClass: "control-label"
	  }, ["手机号："]), " ", _h('div', {
	    staticClass: "info_detail"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.tel),
	      expression: "tel"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "tel",
	      "id": "inputTel",
	      "placeholder": "电话号码"
	    },
	    domProps: {
	      "value": _vm._s(_vm.tel)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.tel = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', {
	    staticClass: "control-label"
	  }, ["邮　箱："]), " ", _h('div', {
	    staticClass: "info_detail"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "inputEmail",
	      "placeholder": "邮箱"
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })])]), " ", _h('div', {
	    staticClass: "form-group"
	  }, [_h('label', {
	    staticClass: "control-label"
	  }, ["密　码："]), " ", _h('div', {
	    staticClass: "info_detail"
	  }, [_h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pwd),
	      expression: "pwd"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "inputPassword",
	      "placeholder": "确认密码"
	    },
	    domProps: {
	      "value": _vm._s(_vm.pwd)
	    },
	    on: {
	      "focus": _vm.clearMsg,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pwd = $event.target.value
	      }
	    }
	  })])]), " ", _h('p', {
	    staticClass: "text-center message"
	  }, [_vm._s(_vm.msg)]), " ", _h('p', {
	    staticClass: "tit_form"
	  }), " ", _h('div', {
	    staticClass: "text-center m_t_m"
	  }, [_h('button', {
	    staticClass: "btn btn-success",
	    on: {
	      "click": _vm.resetprofile
	    }
	  }, ["保存"])])])])])])
	},staticRenderFns: []}

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "welcome"
	  })
	},staticRenderFns: []}

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "management"
	    }
	  }, [_h('h4', [_h('center', ["当前为管理清单分类页，暂未完成"])]), " ", _h('ul', [_vm._l((_vm.items), function(item) {
	    return _h('li')
	  })])])
	},staticRenderFns: []}

/***/ },
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.3ae781783b2e10af5547.js